import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Grid, IconButton, Link } from '@mui/material';
import { openDrawer } from 'store/slices/menu';
import { useDispatch, useSelector } from 'store';

import NavDrawer from '../Drawer';

const hotmobLogo = `${process.env.REACT_APP_BASE_URL}/img/static/header/logo.png`;
const menuIcon = `${process.env.REACT_APP_BASE_URL}/img/static/header/menu.png`;

const MobileView = () => {
    const dispatch = useDispatch();

    const { drawerOpen } = useSelector((state) => state.menu);

    const handleToggleDrawer = () => {
        dispatch(openDrawer(!drawerOpen));
    };

    return (
        <>
            <Grid container spacing={0} sx={{ width: '100% !important', marginLeft: '0 !important' }}>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            width: '100%',
                            minHeight: '80px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '20px',
                            alignItems: 'center'
                        }}
                    >
                        <Link component={RouterLink} to="/">
                            <img alt="hotmob-logo" src={hotmobLogo} width="90" height="36" style={{ width: '90px', height: 'auto' }} />
                        </Link>
                        <IconButton aria-label="Open menu" onClick={handleToggleDrawer} sx={{ padding: 0 }}>
                            <img alt="menu-icon" src={menuIcon} width="24" height="24" style={{ width: '24px', height: '24px' }} />
                        </IconButton>
                    </Box>
                </Grid>
            </Grid>
            <NavDrawer />
        </>
    );
};

export default MobileView;
